import { api } from './api';

/** Free-form pixel position of one repository entry on a timeline's vertical axis. See `TimelineRecordMeta` (untwyn-api). */
export interface TimelineRecordMetaDto {
	id: string;
	parentId: string;
	targetId: string;
	y: number;
}

export interface TimelineRecordMetaListResponseDto {
	data: TimelineRecordMetaDto[];
}

export interface PutTimelineRecordMetaDto {
	parentId: string;
	targetId: string;
	y: number;
}

export const timelineRecordMetaApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTimelineMetaByTimelineId: builder.query<TimelineRecordMetaListResponseDto, string>({
			query: (timelineId) => ({
				url: `timelines/${timelineId}/meta`,
				method: 'GET',
			}),
		}),
		getTimelineMetaByRepositoryId: builder.query<TimelineRecordMetaListResponseDto, string>({
			query: (repositoryId) => ({
				url: `timelines/repository/${repositoryId}/meta`,
				method: 'GET',
			}),
		}),
		putTimelineRecordMeta: builder.mutation<TimelineRecordMetaDto, PutTimelineRecordMetaDto>({
			query: (payload) => ({
				url: `timelines/${payload.parentId}/meta`,
				method: 'PUT',
				body: payload,
			}),
			extraOptions: { maxRetries: 0 },
		}),
	}),
});

export const {
	useGetTimelineMetaByTimelineIdQuery,
	useGetTimelineMetaByRepositoryIdQuery,
	usePutTimelineRecordMetaMutation,
} = timelineRecordMetaApi;
